export default [
    {
        path: "/contracts",
        name: "contracts-list",
        component: () => import("@/views/contract/contracts-list/ContractsList.vue"),
        meta:{
            action: "read",
            resource: "Auth",
        }
    },
    {
        path: "/contracts/list/:id_number",
        name: "contracts-list",
        component: () => import("@/views/contract/contracts-list/ContractsList.vue"),
        meta:{
            action: "read",
            resource: "Auth",
        }
    },
    {
        path: "/contracts/create",
        name: "contracts-create",
        component: () => import("@/views/contract/contracts-edit/ContractEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/contracts/edit/:id",
        name: "contracts-edit",
        component: () => import("@/views/contract/contracts-edit/ContractEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/contracts/copy/:id",
        name: "contracts-copy",
        component: () => import("@/views/contract/contracts-edit/ContractEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/contracts/schedule/:id",
        name: "contracts-schedule-edit",
        component: () => import("@/views/contract/contracts-edit/ContracScheduletEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },

     {
        path: "/contracts",
        name: "contracts-list",
        component: () => import("@/views/contract/contracts-list/ContractsList.vue"),
        meta:{
            action: "read",
            resource: "Auth",
        }
    },
    {
        path: "/contracts/list/:id_number",
        name: "contracts-list",
        component: () => import("@/views/contract/contracts-list/ContractsList.vue"),
        meta:{
            action: "read",
            resource: "Auth",
        }
    },
    {
        path: "/contracts/create",
        name: "contracts-create",
        component: () => import("@/views/contract/contracts-edit/ContractEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/contracts/edit/:id",
        name: "contracts-edit",
        component: () => import("@/views/contract/contracts-edit/ContractEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/contracts/copy/:id",
        name: "contracts-copy",
        component: () => import("@/views/contract/contracts-edit/ContractEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/contracts/schedule/:id",
        name: "contracts-schedule-edit",
        component: () => import("@/views/contract/contracts-edit/ContracScheduletEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },

    // oca 
    {
        path: "/oca",
        name: "oca-list",
        component: () => import("@/views/payment/oca/ocas-list/OcasList.vue"),
        meta:{
            action: "read",
            resource: "Auth",
        }
    },
    {
        path: "/oca/list/:id_number",
        name: "oca-list",
        component: () => import("@/views/payment/oca/ocas-list/OcasList.vue"),
        meta:{
            action: "read",
            resource: "Auth",
        }
    },
    {
        path: "/oca/create",
        name: "oca-create",
        component: () => import("@/views/payment/oca/oca-edit/OcaEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/oca/edit/:id",
        name: "oca-edit",
        component: () => import("@/views/payment/oca/oca-edit/OcaEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/oca/copy/:id",
        name: "oca-copy",
        component: () => import("@/views/payment/oca/oca-edit/OcaEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/oca/schedule/:id",
        name: "oca-schedule-edit",
        component: () => import("@/views/payment/oca/oca-edit/OcaScheduletEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },


    // pi 
    {
        path: "/pi",
        name: "pi-list",
        component: () => import("@/views/payment/oca/ocas-list/OcasList.vue"),
        meta:{
            action: "read",
            resource: "Auth",
        }
    },
    {
        path: "/pi/list/:id_number",
        name: "pi-list",
        component: () => import("@/views/payment/oca/ocas-list/OcasList.vue"),
        meta:{
            action: "read",
            resource: "Auth",
        }
    },
    {
        path: "/pi/create",
        name: "pi-create",
        component: () => import("@/views/payment/oca/oca-edit/OcaEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/pi/edit/:id",
        name: "pi-edit",
        component: () => import("@/views/payment/oca/oca-edit/OcaEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/oca/copy/:id",
        name: "oca-copy",
        component: () => import("@/views/payment/oca/oca-edit/OcaEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
    {
        path: "/pi/schedule/:id",
        name: "pi-schedule-edit",
        component: () => import("@/views/payment/oca/oca-edit/OcaScheduletEdit.vue"),
        meta:{
            action:"read",
            resource:"Auth"
        }
    },
]